/**
 * Full-page centered loader used for all app-level loading states.
 * Visually identical to the pre-React shell loader in public/index.html so the
 * hand-off from static HTML to React shows no change. Light theme, no dependency
 * on Orion theme context (so it is always visible, even before flags resolve).
 */
export const FullPageSpinner = (): JSX.Element => (
  <div className="app-loader" role="status" aria-label="Loading">
    <svg className="app-loader__ring" viewBox="0 0 50 50" aria-hidden="true">
      <circle className="app-loader__track" cx="25" cy="25" r="20" fill="none" strokeWidth="5" />
      <circle
        className="app-loader__arc"
        cx="25"
        cy="25"
        r="20"
        fill="none"
        strokeWidth="5"
        strokeLinecap="round"
        strokeDasharray="90 126"
      />
    </svg>
    <span className="app-loader__label">Loading</span>
  </div>
);
